import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class AuthClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async refreshToken(refreshToken) {
    try {
      const { accessToken, refreshToken } = await this.api.post('/auth/refreshToken', { refreshToken });
      return {
        accessToken,
        refreshToken,
      };
    } catch (error) {
      throw this.error.message(error, 'Error ao fazer refresh do token');
    }
  }

  async verificaToken() {
    try {
      const { data } = await this.api.get('/auth/verifyToken');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Error ao verificar token');
    }
  }

  async me() {
    try {
      const { data } = await this.api.get('/auth/me');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Error ao buscar usuário');
    }
  }

  async alterarSenha({ senhaAtual, novaSenha, confirmacaoNovaSenha }) {
    try {
      const { data } = await this.api.post('/auth/alterarSenha', {
        senhaAtual,
        novaSenha,
        confirmacaoNovaSenha,
      });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Não foi possível alterar a senha');
    }
  }
}
